import { render } from "./Slider.vue?vue&type=template&id=54c2cec9"
const script = {}
script.render = render

export default script